// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"SucursalesTable_spinnerContainer__+iPzR"};